<template>
  <RevInfoBlock
    :content="warningLabel"
    :icon="IconWarning"
    :title="i18n(translations.warningTitle)"
    variant="warning"
  />
  <ul class="body-2 mt-12 list-disc space-y-12 pl-20">
    <li v-if="refundInfo.orderlineQuantity > 1">
      {{
        i18n(translations.productQuantityRemark, {
          productQuantity: refundInfo.orderlineQuantity,
        })
      }}
    </li>
    <li v-if="refundInfo.hasActiveInsurancePolicies">
      {{ i18n(translations.insurancePolicyRemark) }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import type { RefundInfo } from '../../../../ActionBar.machine.type'

import translations from './RefundWarning.translations'

const i18n = useI18n()

const { refundInfo } = defineProps<{
  refundInfo: RefundInfo
}>()

const warningLabel = computed(() => {
  if (!refundInfo.isPartialRefundAllowed) {
    return i18n(translations.fullRefundLabel, {
      maxRefundablePrice: i18n.price(refundInfo.maxRefundPrice),
    })
  }

  return i18n(translations.defaultLabel, {
    maxRefundablePrice: i18n.price(refundInfo.maxRefundPrice),
  })
})
</script>
